module.exports = __webpack_public_path__ + "img/zz.42373c06.png";